import { createSlice } from '@reduxjs/toolkit';
import { useSelector, useDispatch } from 'react-redux';
import {
  LoanCreationApi,
  LoanCreationApi_extrareducer,
} from './loan-creation/index';

const initialState = {
  loanCreationApiState: {
    response: {},
    isLoading: false,
    isError: false,
    isSuccess: false,
  },
};

export const LoanCreationSlice = createSlice({
  name: 'loanCreation',
  initialState,
  extraReducers: {
    ...LoanCreationApi_extrareducer,
  },
});

export function useLoanCreationStore() {
  const loanCreationApiState = useSelector(
    (state) => state.loanCreation.loanCreationApiState
  );

  const dispatch = useDispatch();

  return {
    loanCreationApiState,
    LoanCreationApi: (payload) => dispatch(LoanCreationApi(payload)),
  };
}

export default LoanCreationSlice.reducer;
